<template>
  <vs-table
    :multiple="multiple"
    no-data-text="No tienes pasajeros"
    v-model="passengersSelected"
    :data="passengers"
    class="table"
  >
    <template slot="thead">
      <vs-th>Nombre</vs-th>
      <vs-th>Rut</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
        <vs-td :data="data[indextr].label">
          {{tr.label}}
        </vs-td>
        <vs-td :data="data[indextr].iut">
          {{tr.iut}}
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>
<script>
export default {
  data() {
    return {
      passengersSelected: this.value || []
    };
  },
  watch: {
    passengersSelected() {
      this.$emit('input', this.passengersSelected);
    },
    value(newValue) {
      this.passengersSelected = newValue;
    }
  },
  props: {
    passengers: {
      type: Array,
      required: false,
      default: () => []
    },
    value: {
      type: Array,
      required: true,
      default: () => []
    },
    multiple: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>
